import React, { memo } from 'react';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { ColWrapperStyled, ContainerStyled } from './ColumnNamesStyled';
export const ColumnNames = memo(() => {
    const { t } = useTranslation();
    return (React.createElement(ContainerStyled, null,
        React.createElement(ColWrapperStyled, { width: "328px" },
            React.createElement(RegularTextLevel4, { color: colorCoreBlack300 }, t('returnForm_selectItemsItemColumn_header'))),
        React.createElement(ColWrapperStyled, { justifyContent: "flex-end", width: "240px" },
            React.createElement(RegularTextLevel4, { color: colorCoreBlack300 }, t('returnForm_selectItemsReasonColumn_header'))),
        React.createElement(ColWrapperStyled, { justifyContent: "flex-end", width: "94px" },
            React.createElement(RegularTextLevel4, { color: colorCoreBlack300 }, t('returnForm_selectItemsQtyColumn_header'))),
        React.createElement(ColWrapperStyled, { justifyContent: "flex-end", width: "128px" },
            React.createElement(RegularTextLevel4, { color: colorCoreBlack300 }, t('returnForm_selectItemsTotalPaidColumn_header')))));
});
ColumnNames.displayName = 'ColumnNames';
